/**
 * Client / Brand Manager Support Hub — client-wide, masterAccountId-scoped.
 * Lives under Brand Manager shell, not the brand/master-account shell.
 */
export const CLIENT_SUPPORT_HUB_PATH = "/brand-manager/support";

/**
 * Brand-scoped Support (SUPPORT-QA-01): Support entered from inside a selected
 * Brand (brand shell / MasterLayout). Lists, creates and opens ONLY that
 * Brand's Cases; server enforces the same boundary (?brandId=).
 * Without a resolvable Brand context this path redirects to the Client hub.
 */
export const BRAND_SUPPORT_PATH = "/master-account/support";

/** Same path — historically redirected unconditionally to the Client hub. */
export const LEGACY_MASTER_ACCOUNT_SUPPORT_PATH = BRAND_SUPPORT_PATH;

export function isBrandSupportPath(pathname) {
  const path = String(pathname || "");
  return (
    path === BRAND_SUPPORT_PATH || path.startsWith(`${BRAND_SUPPORT_PATH}/`)
  );
}

export function isClientSupportHubPath(pathname) {
  const path = String(pathname || "");
  return (
    path === CLIENT_SUPPORT_HUB_PATH ||
    path.startsWith(`${CLIENT_SUPPORT_HUB_PATH}/`)
  );
}

export function isLegacyMasterAccountSupportPath(pathname) {
  const path = String(pathname || "");
  return (
    path === LEGACY_MASTER_ACCOUNT_SUPPORT_PATH ||
    path.startsWith(`${LEGACY_MASTER_ACCOUNT_SUPPORT_PATH}/`)
  );
}

/**
 * Preserve query/hash when migrating legacy Support URLs to the Brand Manager hub.
 */
export function toClientSupportHubLocation(locationLike) {
  const search =
    typeof locationLike === "string"
      ? ""
      : String(locationLike?.search || "");
  const hash =
    typeof locationLike === "string"
      ? ""
      : String(locationLike?.hash || "");
  return `${CLIENT_SUPPORT_HUB_PATH}${search}${hash}`;
}
